import dynamic from 'next/dynamic';
import React, { useState } from "react";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import ReportModal from "../../../partials/header/Tools/report-modal";
import MessageModal from "../../../ui/Message-Modal";
import { useAuth } from "@/contexts/authContext";
import Image from "next/image";
import {
  watchSentReports,
  checkSentReportsForDisabling,
} from "@/utils/helpers/helperFunctions";

import Icon from '@/components/ui/Icon';

// Constants
const SOCIAL_LINKS = [
  // { href: "https://t.me/metaxseed", icon: "fa6-brands:telegram" },
  { href: "https://discord.com/invite/metaxseed", icon: "fa6-brands:discord" },
  { href: "https://twitter.com/metaxseed", icon: "proicons:x-twitter" },
  { href: "https://medium.com/metaxseed-games", icon: "la:medium" },
  { href: "mailto:contact@metaxseed.io", icon: "mdi:email" },
];

const TOOLTIP_CONFIG = {
  id: "report-issue-tooltip",
  content: "Report Issue",
  place: "bottom",
  className: "!rounded-full px-4 py-2 gothamBook font-normal !bg-metaxseed-content-gray text-white z-50",
};

const SocialButtons = () => {
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [showErrorModalForReportTry, setShowErrorModalForReportTry] = useState(false);
  const [showSuccessModalForReport, setShowSuccessModalForReport] = useState(false);
  const { user, isWalletConnected: isConnected } = useAuth();

  const handleReportClick = () => {
    if (!user || !isConnected) {
      window.open("https://forms.gle/QEcczpQwyxupKN3Y8", "_blank");
    } else {
      if (checkSentReportsForDisabling()) {
        setIsReportModalOpen(true);
      } else {
        setShowErrorModalForReportTry(true);
      }
    }
  };

  const buttonClasses = "px-1 py-1 bg-metaxseed-dark-gray rounded-md flex justify-center items-center border border-metaxseed-gray transition-colors duration-200";
  const iconClasses = "w-5 h-5";

  const SocialButton = ({ href, icon, ariaLabel }) => (
    <button
      className={buttonClasses}
      onClick={() => window.open(href, "_blank")}
      aria-label={ariaLabel}
    >
      <Icon
        icon={icon}
        className={`${iconClasses} text-gray-400 hover:text-white`}
      />
    </button>
  );

  return (
    <div className="flex flex-row justify-start items-center gap-x-3">
      {SOCIAL_LINKS.map((link, index) => (
        <SocialButton
          key={index}
          href={link.href}
          icon={link.icon}
          ariaLabel={`Visit ${link.icon.split(':')[1]} page`}
        />
      ))}

      <button
        className={buttonClasses}
        onClick={handleReportClick}
        data-tooltip-id={TOOLTIP_CONFIG.id}
        aria-label="Report Issue"
      >
        <Icon
          icon="ic:baseline-report"
          className={`${iconClasses} text-gray-400 hover:text-white`}
        />
      </button>

      <Tooltip {...TOOLTIP_CONFIG} />

      {showSuccessModalForReport && (
        <MessageModal
          title="Thank you!"
          fireworks={false}
          status={true}
          centered
          activeModal={showSuccessModalForReport}
          onClose={() => setShowSuccessModalForReport(false)}
        >
          <div className="flex items-center">
            <Image
              src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fgeneral_media%2F0c72afb44d6ff7f0e7280d050c078407_w200.webp?alt=media&token=6edb828c-a3a5-482d-8ca1-4bdcb1f734ec"
              width={200}
              height={200}
              alt="Success"
              className="mb-4 max-h-[100px] xl:max-h-[200px] !max-w-fit mx-auto"
              priority
            />
          </div>
          <div className="gothamBook text-metaxseed-text-gray py-2 text-center">
            Thanks for participating and helping us maintain the quality of our
            service. Your report has been successfully submitted.
          </div>
        </MessageModal>
      )}

      {showErrorModalForReportTry && (
        <MessageModal
          title="Limit Exceeded!"
          fireworks={false}
          status={false}
          centered
          activeModal={showErrorModalForReportTry}
          onClose={() => setShowErrorModalForReportTry(false)}
        >
          <div className="flex items-center">
            <Image
              src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fgeneral_media%2F2iFb.gif?alt=media&token=e94a95a8-710f-4f13-84a3-eeb821318379"
              width={200}
              height={200}
              alt="Error"
              className="mb-4 max-h-[100px] xl:max-h-[200px] !max-w-fit mx-auto"
              priority
            />
          </div>
          <div className="gothamBook text-metaxseed-text-gray py-2 text-center">
            We're sorry, but you've reached the maximum limit for report
            submissions within one hour. Please try again later.
          </div>
        </MessageModal>
      )}

      {isReportModalOpen && (
        <ReportModal
          user={user}
          isOpen={isReportModalOpen}
          onClose={(e) => {
            setIsReportModalOpen(false);

            // Only show success modal if 'e' is explicitly true (successful report submission)
            if (e === true) {
              setShowSuccessModalForReport(true);
              watchSentReports(user);
            }
          }}
        />
      )}
    </div>
  );
};

export default SocialButtons;
